import { Lightning } from '@lightningjs/sdk';
import { WHITE } from '../../utils/colors';

export const makeButtonTexture = (w, h, borderRadius = 0, borderWidth = 0, borderColor = 0, fillColor = WHITE) =>
  Lightning.Tools.getRoundRect(w, h, borderRadius, borderWidth, borderColor, true, fillColor);
